import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import Grid from '../../components/Grid';
import Image from '../../components/Image';
import PageTitle from '../../components/PageTitle';
import messages from './messages';
import CalendarImg from './calendar.png';

import './styles.css';

const OverviewNoResults = () => (
  <Grid centered stretched styleName="overview-no-results-grid" data-cy="overview-no-results-grid">
    <PageTitle subTitle="Travel Plan" title="RepVisits" category="Intersect" />
    <Grid.Row>
      <Grid.Column styleName="overview-no-results-row overview-results-header">
        <FormattedMessage {...messages.overviewNoResults} />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column>
        <Image src={CalendarImg} centered alt="locked" styleName="overview-no-results-image" />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column styleName="overview-no-results-row" data-cy="overview-no-results-row">
        <span>
          <FormattedMessage
            {...messages.makeAppointments}
            values={{
              searchAndScheduleLink: (
                <Link to="/rep-visits/search">
                  <span>
                    <FormattedMessage {...messages.searchAndSchedule} />
                  </span>
                </Link>
              ),
            }}
          />
        </span>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default OverviewNoResults;
